import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/esm/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink, useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import logo from '../logo.png';
import { ROLE_ADMIN } from '../constants';
import RebuyModal from './entries/RebuyModal';
import { useState } from 'react';

function Header(props) {
  const [showRebuyModal, setShowRebuyModal] = useState(false);
  const navigate = useNavigate();

  const logout = () => {
    props.setToken('');
    navigate('/');
  }

  function userMessage() {
    if (props.user) {
      return (
        <>
          <Nav.Item className="d-sm-flex align-items-center">
            <span className="me-3">Welcome, {props.user.name}. Balance: ${props.user.balance}, Debt: ${props.user.debt}</span>
            <div className="pe-3"><Button variant="success" onClick={() => setShowRebuyModal(true)}>Add Money</Button></div>
            <Button onClick={logout}>Logout</Button>
          </Nav.Item>
        </>
      );
    } else {
      return (
        <Nav.Item>
          <Button onClick={() => props.setShowLoginModal(true)}>Login</Button>
        </Nav.Item>
      );
    }
  }

  return (
    <>
      <Navbar sticky="top" variant="dark" bg="dark" expand="lg">
        <Container fluid>
          <LinkContainer to="/">
            <Navbar.Brand>
              <img src={logo} alt="Buckeye Helmet Sticker" width="35" height="35" className="d-inline-block align-text-top me-2"></img>
              <span className="align-middle">BUCKEYE PICKEM</span>
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              { props.user && <Nav.Item><NavLink className="nav-link" to={"/results"}>Results</NavLink></Nav.Item> }
              { props.user && <Nav.Item><NavLink className="nav-link" to={"/entries"}>My Entries</NavLink></Nav.Item> }
              { props.user && props.user.role === ROLE_ADMIN && <Nav.Item><NavLink className="nav-link" to={"/admin"}>Admin</NavLink></Nav.Item> }
            </Nav>
            <Nav>
              {userMessage()}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <RebuyModal show={showRebuyModal} setShow={setShowRebuyModal} setUser={props.setUser} />
    </>
  );
}

export default Header;